<template>
  <a-modal
    ref="createModal"
    title="拆单排产"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
  >
    <div class="title-text">原工单信息</div>
    <ls-info-form :splitNumber="3" style="padding-left: 8px">
      <ls-info-item slot="wipEntityName" title="工单号" :value="baseData.wipEntityName" IsContentTip></ls-info-item>
      <ls-info-item slot="itemCode" title="物料编码" :value="baseData.assemblyItemCode" IsContentTip></ls-info-item>
      <ls-info-item slot="itemName" title="物料名称" :value="baseData.assemblyItemName" IsContentTip></ls-info-item>
      <ls-info-item slot="workShopDesc" title="车间" :value="baseData.workShopDesc" IsContentTip></ls-info-item>
      <ls-info-item slot="workCenterName" title="工作中心" :value="baseData.workCenterName" IsContentTip></ls-info-item>
      <ls-info-item slot="teamGroupName" title="班组" :value="baseData.teamGroupName" IsContentTip></ls-info-item>
      <ls-info-item slot="planQuantity" title="计划数量" :value="baseData.sourcePlanQuantity" IsContentTip></ls-info-item>
      <ls-info-item slot="scheduledStartDate" title="计划开始时间" :value="baseData.scheduledStartDate" IsContentTip></ls-info-item>
      <ls-info-item slot="scheduledCompletionDate" title="计划完成时间" :value="baseData.scheduledCompletionDate" IsContentTip></ls-info-item>
    </ls-info-form>
    <div class="title-text top-line mt-8">拆分工单信息</div>
    <a-form-model ref="ruleForm" :model="formData">
      <lsMetable
        class="editMaterial"
        :columns="columns"
        :data-list="formData.dataList"
        :scroll="{y:300}"
        :IsEdit="false"
        :loading="loading"
        @addDataList="addDataList"
      >
        <template slot="planQuantity" slot-scope="{ text, record, index }">
          <a-form-model-item v-if="index > 0" :prop="'dataList.' + index + '.planQuantity'" :rules="requiredRules">
            <a-input-number v-model="record.planQuantity" allowClear @change="onChangeQuantity" :precision="0" />
          </a-form-model-item>
          <template v-else>{{ record.planQuantity }}</template>
        </template>
        <template slot="workCenterCode" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.workCenterCode'">
            <global-select
              :value.sync="record.workCenterCode"
              selectType="selectAssembleSearch"
              assembleLabel
              searchParam="centerName"
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ workshopCode: baseData.workCode }"
              @change="getTeam(record, 'workCenter')"
            />
          </a-form-model-item>
        </template>
        <template slot="teamGroupCode" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.teamGroupCode'">
            <global-select
              :value.sync="record.teamGroupCode"
              selectType="selectAssembleSearch"
              assembleLabel
              focusGet
              :selectData="record.defaultTeamList || []"
              searchParam="teamName"
              requestApi="/bom/team/list"
              :selectItem="{ value: 'teamCode', label: 'teamName' }"
              :setParams="{ workshopCode: baseData.workCode, centerCode: record.workCenterCode }"
            />
          </a-form-model-item>
        </template>
        <template slot="scheduledStartDate" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.scheduledStartDate'" :rules="requiredRules">
            <a-date-picker
              v-model="record.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              allowClear
              :show-time="{ defaultValue: $moment('08:00:00', 'HH:mm:ss') }"
              @change="() => getTeam(record)"
              :disabledDate="disabledDate"
              style="min-width: 100%"
            />
          </a-form-model-item>
        </template>
        <template slot="scheduledCompletionDate" slot-scope="{ text, record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.scheduledCompletionDate'" :rules="requiredRules">
            <a-date-picker
              v-model="record.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('23:59:59', 'HH:mm:ss') }"
              allowClear
              @change="() => getTeam(record)"
              :disabledDate="disabledDate"
              style="min-width: 100%"
            />
          </a-form-model-item>
        </template>
        <template slot="operation" slot-scope="{text,record,index}">
          <ls-cancel v-if="index > 0" @confirm="deleteList(record,index)" title="确定要删除吗?">
            <a-icon type="delete" title="删除"/>
          </ls-cancel>
        </template>
      </lsMetable>
    </a-form-model>
    <a-space slot="footer">
      <a-button @click="onClose">取消</a-button>
      <a-button @click="onConfirmSchedule" :loading="confirmLoading" type="primary">确认排产</a-button>
      <a-button @click="onConfirmPublish" :loading="confirmLoading" type="primary">确认并发布</a-button>
    </a-space>
  </a-modal>
</template>

<script>
import {
  apiGetConfirmScheduleMesDiscreteJobsCcInfo,
  apiGetBomTeamScheduleCcList,
  apiSplitOrderConfirmPc,
  apiSplitOrderConfirmPublish, apiGetBomTeam
} from '@/api/mes/workOrderManage/ticketsManageCc'
import { mapState } from 'vuex'
import omit from 'lodash/omit'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'SplitOrderModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      confirmLoading: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      formData: {
        dataList: []
      },
      requiredRules: [{ required: true, message: ' ', trigger: 'change' }],
      baseData: {},
      columns: [
        { dataIndex: 'planQuantity', title: '数量', scopedSlots: { customRender: 'planQuantity' }, width: 100 },
        { dataIndex: 'workCenterCode', title: '工作各中心', scopedSlots: { customRender: 'workCenterCode' }, width: 140 },
        { dataIndex: 'teamGroupCode', title: '班组', scopedSlots: { customRender: 'teamGroupCode' }, width: 140 },
        { dataIndex: 'scheduledStartDate', title: '计划开始时间', scopedSlots: { customRender: 'scheduledStartDate' }, width: 160 },
        { dataIndex: 'scheduledCompletionDate', title: '计划完成时间', scopedSlots: { customRender: 'scheduledCompletionDate' }, width: 160 },
        { dataIndex: 'operation', title: '操作', scopedSlots: { customRender: 'operation' }, width: 70 }
      ]
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  methods: {
    addDataList() {
      this.formData.dataList.push(this.getInitData());
    },
    deleteList(record, index) {
      this.formData.dataList.splice(index, 1);
      this.onChangeQuantity();
    },
    getTeam(record, from) {
      const startTime = record.scheduledStartDate && this.$moment(record.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss');
      const endTime = record.scheduledCompletionDate && this.$moment(record.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss');
      const params = {
        startTime,
        endTime,
        workshopCode: this.baseData.workCode,
        centerCode: record.workCenterCode,
        enable: 1
      }
      if(from === 'workCenter') {
        record.teamGroupCode = '';
      }
      if(startTime && endTime && params.workshopCode && params.centerCode) {
        apiGetBomTeamScheduleCcList(params).then(res => {
          if (res.code === 200) {
            const { rows = [] } = res;
            const teamCode = rows[0]?.teamCode;
            if(teamCode) {
              record.teamGroupCode = teamCode
            }else {
              if(from === 'workCenter' && record.workCenterCode) {
                this.getTeamByWorkCenter(record);
              }
            }
          }
        })
      }
    },
    // 仅通过工作中心获取班组，该接口去重
    getTeamByWorkCenter(record) {
      const params = {
        centerCode: record.workCenterCode,
        workshopCode: this.baseData.workCode
      }
      apiGetBomTeam(params).then(res => {
        if(res.code === 200) {
          const { rows = [] } = res;
          const teamCode = rows[0]?.teamCode;
          if(teamCode) {
            record.teamGroupCode = teamCode;
            record.defaultTeamList = [ rows[0] ]
          }
        }
      })
    },
    onChangeQuantity() {
      const firstItem = this.formData.dataList[0];
      const otherTotal = this.formData.dataList.slice(1).reduce((total, item) => {
        return total + Number(item.planQuantity || 0);
      }, 0);
      firstItem.planQuantity = this.getFixed(Number(this.baseData.sourcePlanQuantity) - otherTotal, 4);
    },
    getFixed(value, decimal = 2) {
      return Number(Number(value)._toFixed(decimal))
    },
    show (itemData) {
      this.visible = true
      this.confirmLoading = false
      this.getData(itemData.id);
    },
    getData(id) {
      this.loading = true;
      apiGetConfirmScheduleMesDiscreteJobsCcInfo({ id }).then(res => {
        if(res.code === 200) {
          const { data = {} } = res;
          const baseData = omit(data, ['detailList']);
          const dataList = data.detailList || [];
          dataList.unshift(cloneDeep(baseData));
          this.formData.dataList = dataList;
          this.baseData = baseData;
          if(dataList.length === 1) {
            this.addDataList()
          }
          this.formData.dataList.forEach(item => {
            item.defaultTeamList = [{ teamCode: item.teamGroupCode, teamName: item.teamGroupName }]
          })
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 关闭模态框
    onClose () {
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    },
    getParams() {
      let params = null;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const detailList = this.formData.dataList.map(item => {
            return {
              ...item,
              scheduledStartDate: this.$moment(item.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss'),
              scheduledCompletionDate: this.$moment(item.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss')
            }
          })
          params = {
            ...this.baseData,
            ...detailList[0],
            detailList: detailList.slice(1)
          }
        }
      })
      return params
    },
    onConfirmPublish () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true;
      this.$emit('update:mainBtnLoading', true);
      apiSplitOrderConfirmPublish(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('successCall')
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
        this.$emit('update:mainBtnLoading', false);
      })
    },
    onConfirmSchedule () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true
      this.$emit('update:mainBtnLoading', true);
      apiSplitOrderConfirmPc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('successCall')
          // 刷新表单
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$emit('update:mainBtnLoading', false);
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.formData = {
          dataList: []
      };
    },
    getInitData() {
      return {
        scheduledCompletionDate: this.baseData.scheduledCompletionDate,
        scheduledStartDate: this.baseData.scheduledStartDate,
        teamGroupCode: undefined,
        workCenterCode: undefined,
        planQuantity: null,
        defaultTeamList: []
      }
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current < this.$moment().startOf('day');
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 130px;
}
input{
  width: 100%;
}
/deep/.ant-input-number{
  width: 100%;
}
/deep/.ant-form-item {
  margin: 0
}
/deep/.ant-form-explain {
  position: absolute;
}
.title-text {
  font-size: 15px;
  margin-bottom: 8px;
}
.top-line {
  border-top: #9faab1 solid 1px;
}
.mt-8 {
  margin-top: 8px;
}
</style>
